import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, FormGroupComponent, ModalFooterDirective, RadioComponent } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { MbsPopupType } from 'mbs-ui-kit/utils/enums/mbs-popup-enum';
import { SaveVariants } from 'wizards/models/base/other-base-models/save-variants';

@Component({
  selector: 'mbs-cant-open-modal',
  templateUrl: './cant-open-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    FormGroupComponent,
    FormsModule,
    ReactiveFormsModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    RadioComponent,
    ModalFooterDirective
  ]
})
export class CantOpenModalComponent implements OnInit {
  private i18nPipe = inject(I18NextPipe);

  public readonly saveVariants = SaveVariants;
  private readonly default = {
    alertType: MbsPopupType.info,
    title: this.i18nPipe.transform('wizards:virtual_wizards_error_version_title', { format: 'title' }),
    text: this.i18nPipe.transform('wizards:virtual_wizards_error_version_text_alert'),
    okButtonText: null,
    showVariants: false,
    cancelButtonText: this.i18nPipe.transform('shared:buttons.close')
  };

  public alertType = this.default.alertType;
  public title = this.default.title;
  public text = this.default.text;
  public okButtonText = null;
  public cancelButtonText = null;
  public showVariants = null;

  public saveVariant = SaveVariants.notSave;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  ngOnInit(): void {
    this.alertType = this.baseModal?.data?.alertType || this.default.alertType;
    this.okButtonText = this.baseModal?.data?.okButtonText || this.default.okButtonText;
    this.cancelButtonText = this.baseModal?.data?.cancelButtonText || this.default.cancelButtonText;
    this.showVariants = this.baseModal?.data?.showVariants || this.default.showVariants;

    if (this.showVariants) {
      this.saveVariant = SaveVariants.saveAfterStop;
      this.okButtonText = this.i18nPipe.transform('wizards:buttons.apply');
    }

    if (this.baseModal?.data?.isInvalidFields) {
      this.title = this.baseModal.data.title || this.i18nPipe.transform('wizards:virtual_wizards_error_fields_title', { format: 'title' });
      this.text = this.baseModal.data.text || this.i18nPipe.transform('wizards:virtual_wizards_error_fields_text_alert');
    } else {
      this.title = this.baseModal?.data?.title || this.default.title;
      this.text = this.baseModal?.data?.text || this.default.text;
    }
  }

  close(): void {
    this.baseModal.close();
  }

  save(): void {
    this.baseModal.save(this.showVariants ? this.saveVariant : SaveVariants.stopAndSave);
  }
}
